import { BasicEnumerable } from "../BasicEnumerable.js";
export const concatenate = (first, second) => {
    function* iterator() {
        yield* first;
        yield* second;
    }
    return new BasicEnumerable(iterator);
};
